import { ProtocolTypes } from '@/models/bud'

const setCategories = (state, categories) => {
  Object.assign(state, { categories })
}

const setProtocolsResult = (state, protocolsResult) => {
  state.protocolsResult = protocolsResult
    .filter(
      node =>
        ![ProtocolTypes.QUESTION, ProtocolTypes.ACTION].includes(node.type)
    )
    .sort((a, b) => a.name.localeCompare(b.name))
}

const setCurrentProtocol = (state, currentProtocol) => {
  if (currentProtocol && !currentProtocol.nodeWithRelationships) {
    currentProtocol.nodeWithRelationships = null
  }
  Object.assign(state, { currentProtocol })
}

const updateCurrentProtocol = (state, nodeWithRelationships) => {
  if (!state.currentProtocol) {
    return
  }
  Object.assign(state.currentProtocol, { nodeWithRelationships })
}

const addToHistory = (state, { channelId, budId }) => {
  if (state.history[channelId]) {
    state.history[channelId].push(budId)
  } else {
    state.history[channelId] = [budId]
  }
}

const removeFromHistory = (state, channelId) => {
  state.history[channelId].splice([state.history[channelId].length - 1], 1)

  if (!state.history[channelId].length) {
    setCurrentProtocol(state, undefined)
  }
}

const setNavigationHistory = (state, navigationHistory) => {
  Object.assign(state, { navigationHistory })
}

const clearNavigationHistory = state => {
  Object.assign(state, { navigationHistory: undefined })
}

const setLoading = (state, loading) => {
  Object.assign(state, { loading })
}

const sentToChannels = (state, sentToChannels) => {
  Object.assign(state, { sentToChannels })
}

export default {
  setCategories,
  setProtocolsResult,
  setCurrentProtocol,
  updateCurrentProtocol,
  addToHistory,
  removeFromHistory,
  setLoading,
  sentToChannels,
  setNavigationHistory,
  clearNavigationHistory
}
